import React from 'react';
import loadable from '@loadable/component';
import { StockIndicator as CoreStockIndicator, Typography as CoreTypography } from '@hpi-sox/hpstellar-core';
import { StockIndicator as OrionStockIndicator, Typography as OrionTypography } from '@hpi-sox/hpstellar-orion';

import { Helpers } from '../../core';
import InventoryMessage from './inventory-message';

const OrionStyleLoader = loadable(() => Helpers.retryFunc(() => import('../../orion/orion-style-loader')));

const getStockStatus = ({ stockStatus, preOrder, backOrderFlag, isOOS } = {}) => {
    if (preOrder || backOrderFlag) return 'preOrder';
    if (isOOS) return 'outOfStock';

    switch ((stockStatus || '').trim().toLowerCase()) {
        case 'green':
            return 'inStock';
        case 'orange':
        case 'red':
            return 'lowStock';
        case 'grey':
            return 'outOfStock';
        default:
            return 'inStock';
    }
};

const ProductStatusBadge = ({
    product,
    displayShipMessage,
    showPreOrderMsg,
    stockIndicatorProps,
    shipDate,
    hasDeliveryLabel,
    orionEnabled,
    hideStatus = [],
    ...otherProps
}) => {
    const StockIndicator = orionEnabled ? OrionStockIndicator : CoreStockIndicator;
    const Typography = orionEnabled ? OrionTypography : CoreTypography;

    return (
        <>
            {orionEnabled && <OrionStyleLoader />}
            <InventoryMessage product={product} showOOS={true} showPreOrderMsg={showPreOrderMsg}>
                {({ stock, shippingMsg, price }) => {
                    const { shipMessage: defaultShippingMessage, estShipMsg, product_type, productType } = product;
                    const { stockMessage, stockStatus, preOrder, backOrderFlag, invAvaDate, isOOS } = price;

                    const stockIndicatorStatus = getStockStatus({
                        stockStatus,
                        preOrder,
                        backOrderFlag,
                        isOOS,
                    });
                    const indicatorProps = orionEnabled
                        ? { status: stockIndicatorStatus, label: stockMessage }
                        : { color: stockStatus, stockMessage, style: { marginTop: '1rem' } };
                    const hiddenStockStatus = hideStatus.length > 0 && hideStatus.includes(stockIndicatorStatus);
                    const shouldHideStockStatus =
                        (!stockMessage && !backOrderFlag) || (hasDeliveryLabel && preOrder) || hiddenStockStatus;
                    let deliveryMessage =
                        displayShipMessage && !isOOS
                            ? shipDate || estShipMsg || shippingMsg || defaultShippingMessage
                            : null;

                    if (shouldHideStockStatus) return null;

                    return (
                        <>
                            {preOrder || backOrderFlag ? (
                                <Typography variant="bodySmall" className={'shippingDateText'}>
                                    {deliveryMessage}
                                </Typography>
                            ) : (
                                <StockIndicator
                                    className="stockIndicator"
                                    deliveryMessage={hasDeliveryLabel ? '' : deliveryMessage}
                                    {...indicatorProps}
                                    {...stockIndicatorProps}
                                    size={
                                        stockIndicatorProps?.size ||
                                        (deliveryMessage && !hasDeliveryLabel ? 'large' : 'small')
                                    }
                                    {...otherProps}
                                />
                            )}
                        </>
                    );
                }}
            </InventoryMessage>
        </>
    );
};

export default ProductStatusBadge;
